import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

export const drawerWidth = "240px";

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  navbar: {
    display: "flex",
  },
  links: {
    marginBottom: theme.spacing(3),
  },
  linkRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
  },
  link: {
    flex: 1,
    minWidth: 0,
    fontSize: 12,
    color: grey[600],
    textAlign: "center",
    overflowWrap: "break-word",
    hyphens: "auto",
  },
  logo: {
    marginBottom: theme.spacing(3),
    marginLeft: theme.spacing(5),
  },
  poweredByText: {
    color: grey[400],
  },
  badge: {
    textAlign: "center",
    minWidth: theme.spacing(3),
  },
  drawerPaper: {
    width: drawerWidth,
    background: "rgb(248, 249, 250)",
  },
  drawerContainer: {
    overflow: "auto",
    flexGrow: 1,
    paddingTop: theme.spacing(3),
  },
  navItem: {
    borderRadius: theme.spacing(0, 5.5, 5.5, 0),
    height: 52,
    fontSize: 14,
    fontWeight: 500,
    color: grey[800],
    paddingLeft: theme.spacing(3),
  },
  navItemSelected: {
    "--dynamic-color": `${theme.palette.secondary.main}`,
    color: theme.palette.primary.main,
    backgroundColor: "var(--dynamic-color) !important",
  },
  navItemIcon: {
    minWidth: 0,
    marginRight: theme.spacing(2),
  },
  drawerText: {
    fontFamily: "Poppins",
    color: "rgba(79, 79, 79, 1)",
    lineHeight: "21px",
    fontWeight: 500,
    fontSize: "14px",
  },
  name: {
    fontFamily: "Poppins",
    color: "rgba(0, 0, 0, 1)",
    lineHeight: "21px",
    fontWeight: 600,
    fontSize: "14px",
    margin: "16px 0px 8px 16px",
  },
  iconBox: {
    height: "24px",
    paddingRight: "20px",
  },
  subName: {
    alignSelf: "center",
    marginTop: theme.spacing(5),
    marginLeft: theme.spacing(-6),
  },
}));

export default useStyles;
